<app-pre-loader *ngIf="IsLoadingResults"></app-pre-loader>

<div mat-dialog-actions>
    <div class="col-md-3 left" *ngIf="_data.IsFormEditable && _data.RecordStatus != 2 && !_global.IsTQApprover">
        <button type="button" style="width: 100%" class="btn-primary1" (click)="OnSave()" mat-stroked-button
            cdkFocusInitial>Save</button>
    </div>
    &nbsp;
    <div class="col-md-3 left" *ngIf="_data.IsShownApprovalButtons && (_global.IsTQApprover || _global.IsAdmin)">
        <button type="button" style="width: 100%" class="btn-primary1" mat-stroked-button
            (click)="OnDoneClick()" cdkFocusInitial>Done</button>
    </div>
    <!-- 6. TQ Comments Processed Without Action & Changes By Rehan For Issue & INTaxGTC Defects by Shipra Mam -->
    <!-- Adeed OnDoneClick on line 11 --> 
    <div class="col-md-3 left">
        <button type="button" style="width: 100%" class="btn-primary1" mat-stroked-button
            (click)="onNoClick()">Cancel</button>
    </div>
</div>

<div mat-dialog-content style="min-height:90%">
    <div class="panel panel-default">

        <div class="panel-body" style="margin: 20px;">
            <div class="row">
                <div class="mb-3 col-md-6">
                    <u style="color: black;">List of added clause & change request </u>
                </div>
            </div>
            <div class="row" *ngIf="IsFilterShown">
                <div class="filterDiv">
                    <form [formGroup]="formGroup">
                        <p-dropdown formControlName="selectedClause" placeholder="Select Sort By"
                            [style]="{'border-bottom':'4px solid #ffe600','border-radius':'4px'}"
                            (onChange)="onFilterchange($event)" [options]="values" optionLabel="name"></p-dropdown>
                    </form>
                </div>

            </div>

            <div class="row">
                <div class="form-input">
                    <div class=" mb-3 col-sm-12">
                        <label *ngIf="IsClauseDropDownShown">Select the clauses where changes have been proposed by the
                            client and that
                            require Tax Quality approval basis GCO comments.</label>
                        <diV *ngIf="IsClauseDropDownShown">
                            <p><strong>Modify Clause</strong> – Select this option when there is modification in the
                                standard clause.</p>
                            <p><strong>Delete Clause</strong> – Select this option when a clause needs to be deleted.
                            </p>
                            <p><strong>Add Clause/Sub Clause</strong> – Select this option when a sub clause needs to be added
                                to the standard clause.</p>

                        </diV>
                        <Label style="color: black;" *ngIf="!IsClauseDropDownShown">Selected Clause Range:
                            {{selectedOption}}</Label>

                        <p-dropdown [options]="clauseMasterDropDownList" *ngIf="IsClauseDropDownShown"
                            optionLabel="label" (onChange)="getClauseDetails($event)"
                            placeholder="Select Clause Range"></p-dropdown>
                    </div>
                </div>

            </div>
            <div class="row">
                <div class="mb-3 col-sm-12" *ngFor="let data of clauseListWithDetails">
                    <div class="cardSearch">

                        <div class="card-header form-control" data-bs-toggle="collapse"
                            attr.href="#{{'ABC' + data.ClauseNumber.toString()}}" role="button" aria-expanded="false"
                            attr.aria-controls="#{{'ABC' + data.ClauseNumber.toString()}}">
                            <header class="panel-heading">
                                <Label class="panel-title">{{"Standard Clause: " + data.ClauseNumber}}
                                </Label>
                                &nbsp;
                                &nbsp;
                                <span *ngIf="data.ClauseRadioType == 1"
                                    style="font-size: medium;color: green;">(Modify)</span>
                                <span *ngIf="data.ClauseRadioType == 2" style="font-size: medium;color: red;">(Delete
                                    Clause)</span>
                                <span *ngIf="data.ClauseRadioType == 3" style="font-size: medium;color: gray;">(No
                                    Change)</span>
                                <span *ngIf="data.ClauseRadioType == 4" style="font-size: medium;color: green;">(
                                    Add Clause/Sub Clause)</span>
                                <span *ngIf="data.ClauseStatus == 1"
                                    style="font-size: medium;color: green;">(Approved)</span>
                                <span *ngIf="data.ClauseStatus == 2"
                                    style="font-size: medium;color: red;">(Rejected)</span>
                                <span *ngIf="data.ClauseStatus == 3"
                                    style="font-size: medium;color: darkred;">(Pushback)</span>
                                &nbsp;&nbsp;
                                <button *ngIf="!checkValueIsNullOrEmptyOrUndefined(data.ClauseGTCID)" 
                                    type="button" mat-stroked-button
                                    style="font-size: 11px; padding: 0px 6px; background-color: grey; color: white; line-height: 20px; height: 22px; min-height: 22px; vertical-align: middle;"
                                    (click)="openClauseAuditTrail(data); $event.stopPropagation();">
                                    <i class="pi pi-history" style="font-size: 10px;"></i> Audit Trail
                                </button>
                                <!-- <input type="file" class="file-input"
  (change)="onFileSelected($event)" #fileUpload> -->


                                <span style="float:right"> <i class="pi pi-arrow-down"></i></span>
                            </header>

                        </div>


                        <div class="collapse" id="{{'ABC' + data.ClauseNumber.toString()}}">

                            <div class="rowAltr" *ngIf="!IsShownTQLeaderView">
                                <div class="mb-3 col-md-10">

                                    <div class="input-group radio-div">

                                        <mat-radio-group [(ngModel)]="data.ClauseRadioType">
                                            <mat-radio-button
                                                [disabled]="!canEditClauseAction(data)"
                                                value="1">Modify Clause</mat-radio-button>
                                            <mat-radio-button
                                                [disabled]="!canEditClauseAction(data)"
                                                value="2">Delete Clause</mat-radio-button>
                                            <mat-radio-button
                                                [disabled]="!canEditClauseAction(data)" value="3">No
                                                Change</mat-radio-button>
                                            <mat-radio-button
                                                [disabled]="!canEditClauseAction(data)"
                                                value="4">Add Clause/Sub Clause</mat-radio-button>
                                        </mat-radio-group>
                                        <!-- <mat-radio-group >
                                    <mat-radio-button  *ngFor="let clause of clauseTypeList"
                                        (change)="radioChange($event)"
                                        [value]="clause.value"
                                    >
                                    {{clause.label}}

                                    </mat-radio-button>
                                    </mat-radio-group> -->
                                    </div>

                                </div>
                            </div>
                            <!-- master clause -->
                            <div class="rowAltr">
                                <div class="mb-3 col-md-12">
                                    <textarea class="form-control" disabled
                                        style="resize:none; height: 110px; border-color: black;">{{data.Description}}</textarea>
                                </div>
                            </div>
                            <!-- Proposed Clause -->
                            <div class="rowAltr" *ngIf="data.ClauseRadioType == 1 || data.ClauseRadioType == 4">
                                <div class="mb-3 col-md-12" style="background-color: lightgray;">
                                    <div class="input-group">
                                        <label>Proposed Edits by Client</label>
                                        &nbsp;
                                        <div mat-raised-button
                                            matTooltip="Changes will appear in track mode in “Modified Clause” section below once you click on Save button">
                                            <i class="pi pi-question-circle"></i>
                                        </div>
                                        &nbsp; &nbsp;

                                    </div>
                                </div>
                                <div class="mb-3 col-md-12">
                                    <textarea class="form-control" [disabled]="isClauseFieldDisabled(data)"
                                        [(ngModel)]="data.ProposedDesc"
                                        (ngModelChange)="proposedDescChange($event ,data)"
                                        style="resize:none; height: 110px; border-color: black;"></textarea>
                                </div>
                            </div>
                            <!-- Changes Proposed By Client -->
                            <div class="rowAltr" *ngIf="data.ClauseRadioType == 1 || data.ClauseRadioType == 4">
                                <div class="mb-3 col-md-12" style="background-color: lightgray;">
                                    <div class="input-group">
                                        <label>Modified Clause</label>
                                        &nbsp;
                                        <div mat-raised-button
                                            matTooltip="Changes will appear automatically once you click on Save button.">
                                            <i class="pi pi-question-circle"></i>
                                        </div>
                                        &nbsp; &nbsp;

                                    </div>

                                </div>

                                <div class="mb-3 col-md-12">
                                    <div class="djkn" [innerHTML]="data.ProposedByClientDesc">


                                    </div>
                                </div>

                            </div>
                            <!-- add sub clause -->
                            <div class="rowAltr" *ngIf="data.ClauseRadioType == 4">
                                <div class="mb-3 col-md-12" style="background-color: lightgray;">
                                    <label>Add Clause/Sub Clause <span class="required" style="color: red">*</span></label>

                                </div>

                                <div class="mb-3 col-md-12">
                                    <textarea class="form-control" [(ngModel)]="data.SubClauseDec"
                                        [disabled]="isClauseFieldDisabled(data)"
                                        style="resize:none; height: 110px; border-color: black;"></textarea>
                                </div>

                            </div>
                            <!-- GCO Comments on the proposed changes  -->
                            <div class="rowAltr"
                                *ngIf="data.ClauseRadioType == 1 || data.ClauseRadioType == 4 || data.ClauseRadioType == 2 ">
                                <div class="mb-3 col-md-12" style="background-color: lightgray;">

                                    <div class="input-group">
                                        <label>GCO Comments on the proposed changes<span class="required"
                                                style="color: red">*</span></label>
                                        &nbsp;
                                        <div mat-raised-button
                                            matTooltip="GCO comments on the proposed change- (Provide reference (page/ para number, document name, email dated etc) to the document with GCO comments).">
                                            <i class="pi pi-question-circle"></i>
                                        </div>
                                        &nbsp; &nbsp;

                                    </div>

                                </div>


                                <div class="mb-3 col-md-12">
                                    <textarea class="form-control" [(ngModel)]="data.GCOComment"
                                        [disabled]="isClauseFieldDisabled(data)"
                                        style="resize:none; height: 110px; border-color: black;"></textarea>
                                </div>

                            </div>
                            <!--Risk mitigation   -->
                            <div class="rowAltr"
                                *ngIf="data.ClauseRadioType == 1 || data.ClauseRadioType == 4 || data.ClauseRadioType == 2 ">
                                <div class="mb-3 col-md-12" style="background-color: lightgray;">
                                    <div class="input-group">
                                        <label>Risk Mitigation Action Plan <span class="required"
                                                style="color: red">*</span></label>
                                        &nbsp;
                                        <div mat-raised-button
                                            matTooltip="Risk Mitigation Action Plan - (Engagement teams' comments on the risk mitigation steps to be undertaken to manage increased risk. You may refer to the indicative risk mitigation action plan available in the India Tax Manual">
                                            <i class="pi pi-question-circle"></i>
                                        </div>
                                        &nbsp; &nbsp;

                                    </div>

                                </div>

                                <div class="mb-3 col-md-12">
                                    <textarea class="form-control" [(ngModel)]="data.RiskMitigationActionPlan"
                                        [disabled]="isClauseFieldDisabled(data)"
                                        style="resize:none; height: 110px; border-color: black;"></textarea>
                                </div>

                            </div>
                            <div class="rowAltr"
                                *ngIf="data.ClauseRadioType == 1 || data.ClauseRadioType == 4 || data.ClauseRadioType == 2 ">
                                <div class="mb-3 col-md-12" style="background-color: lightgray;">
                                    <div class="input-group">
                                        <label>Specific Business Case for Accepting the Edits  <span class="required"
                                                style="color: red">*</span></label>
                                        &nbsp;
                                        <div mat-raised-button
                                            matTooltip="Specific Business Case for Accepting the Edits ">
                                            <i class="pi pi-question-circle"></i>
                                        </div>
                                        &nbsp; &nbsp;

                                    </div>

                                </div>

                                <div class="mb-3 col-md-12">
                                    <textarea class="form-control" [(ngModel)]="data.SpecificBusinessCase"
                                        [disabled]="isClauseFieldDisabled(data)"
                                        style="resize:none; height: 110px; border-color: black;"></textarea>
                                </div>

                            </div>

                            <!--T Q comments  -->
                            <div class="rowAltr"
                                *ngIf="data.ClauseRadioType == 1 || data.ClauseRadioType == 4 || data.ClauseRadioType == 2 ">
                                <div class="mb-3 col-md-12" style="background-color: lightgray;">
                                    <div class="input-group">
                                        <label>TQ Comments</label>
                                        <span *ngIf="canRequestorEditClause(data)" style="margin-left: 10px; color: #666; font-size: 12px;">
                                            (Your comments will be saved in audit trail)
                                        </span>
                                        &nbsp;



                                    </div>

                                </div>

                                <div class="mb-3 col-md-12">
                                    <textarea class="form-control" [(ngModel)]="data.TQComments"
                                        [disabled]="!canEditTQComments(data)"
                                        style="resize:none; height: 110px; border-color: black;"></textarea>
                                </div>

                            </div>

                            <mat-card class="btnCard"
                                *ngIf="(data.ClauseRadioType == 1 || data.ClauseRadioType == 2 || data.ClauseRadioType == 4 ) && _data.IsShownApprovalButtons">
                                <mat-card-actions >


                                    <button class="btn-primary1" type="button"
                                        (click)="OnApprovalStatusChange(data.ClauseID,1)" mat-stroked-button>
                                        Approve
                                    </button>
                                    <button class="btn-primary1" type="submit"
                                        (click)="OnApprovalStatusChange(data.ClauseID,2)" mat-stroked-button>
                                        Reject
                                    </button>
                                    <button class="btn-primary1" type="button"
                                        (click)="OnApprovalStatusChange(data.ClauseID,3)" mat-stroked-button>
                                        Pushback
                                    </button>
                                <input #fileInput 
                                    *ngIf="_data.IsShownApprovalButtons" 
                                    type="file" 
                                    (change)="onFileSelected($event, data, fileInput)" 
                                    name="attachment">
                                </mat-card-actions>
                            </mat-card>
                            <div class="row" style="display: flex; align-items: center;">
                                <a *ngIf="!checkValueIsNullOrEmptyOrUndefined(data.AttachmentName)" style="color: blue; cursor: pointer;" download (click)="onDownload(data)">
                                    {{ data.AttachmentName }}
                                </a>
                                <span *ngIf="!checkValueIsNullOrEmptyOrUndefined(data.AttachmentName) && _data.IsShownApprovalButtons" style="margin-left: 10px; cursor: pointer;" (click)="onDeleteAttachment(data)">
                                    <i class="pi pi-trash" style="color: red;"></i>
                                </span>
                            </div>
                           
                            <!-- <label *ngIf="data.AttachmentName != null" style="color: blue;">{{ data.AttachmentName
                                }}</label> -->



                            <div class="rowAltr" *ngIf="IsShownTQLeaderView">
                                <div class="mb-3 col-md-12" style="background-color: lightgray;">
                                    <label>Tax Quality Leader Comments</label>

                                </div>

                                <div class="mb-3 col-md-12">
                                    <textarea class="form-control" [(ngModel)]="data.TaxQualityLeaderComments"
                                        style="resize:none; height: 110px; border-color: black;"></textarea>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>




        </div>

    </div>

    <div>


    </div>




</div>